import React from 'react';
import { TitleSection } from './components/TitleSection';
import { FareSection } from './components/FareSection';
import { OfferSection } from './components/OfferSection';
import { ReasonsSection } from './components/ReasonsSection';
import { HowToSection } from './components/HowToSection';

export const ContentSection = () => {
    return (
        <>
            <TitleSection />
            <OfferSection />
            <FareSection />
            <ReasonsSection />
            <HowToSection />
        </>
    );
};
